import React, { useEffect, useState } from "react"
import { Card, Button, Spinner, Alert } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import DataTable from "../../../components/DataTable/DataTable"
import service from "../services/billingCycleService"
import { Icon } from "../../../components"

const BillingCycleList = () => {
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let mounted = true
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const response = await service.list()
        let data = []
        if (Array.isArray(response)) data = response
        else if (Array.isArray(response.results)) data = response.results
        else if (Array.isArray(response.data)) data = response.data
        else console.warn("Unexpected response format for billing cycles:", response)
        if (mounted) setRows(data)
      } catch (err) {
        console.error("Error fetching billing cycles", err)
        if (mounted) setError(`Error al cargar ciclos: ${err.message}`)
      } finally {
        if (mounted) setLoading(false)
      }
    })()
    return () => { mounted = false }
  }, [])

  const handleNew = () => navigate("/billing-cycle/new")
  const handleEdit = id => navigate(`/billing-cycle/edit/${id}`)
  const handleDelete = async id => {
    if (!window.confirm("¿Eliminar ciclo?")) return
    setLoading(true)
    try {
      await service.remove(id)
      setRows(prev => prev.filter(r => r.id !== id))
    } catch (err) {
      console.error("Error deleting cycle", err)
      setError(`No se pudo eliminar: ${err.message}`)
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    { name: "ID", selector: r => r.id, sortable: true },
    { name: "Código", selector: r => r.code, sortable: true },
    { name: "Nombre", selector: r => r.name, sortable: true },
    { name: "Meses", selector: r => r.months, sortable: true },
    { name: "Desc %", selector: r => r.discount_percent, sortable: true },
    { name: "Activo", selector: r => (r.active ? "Sí" : "No"), sortable: true },
    {
      name: "Acciones",
      cell: row => (
        <>
          <Button size="sm" variant="outline-primary" className="me-1" onClick={() => handleEdit(row.id)}>
            <Icon name="edit" />
          </Button>
          <Button size="sm" variant="outline-danger" onClick={() => handleDelete(row.id)}>
            <Icon name="trash" />
          </Button>
        </>
      ),
    }
  ]

  return (
    <Layout title="Ciclos de Facturación" content="container" loading={loading}>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Ciclos de Facturación</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <Button variant="primary" onClick={() => navigate("/billing-cycle/new") }>
              <Icon name="plus" />
              <span> Nuevo ciclo de facturación</span>
            </Button>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card body>
          {error && <Alert variant="danger">{error}</Alert>}
          <DataTable
            data={rows}
            columns={columns}
            progressPending={loading}
            noDataComponent={<div>No hay ciclos.</div>}
            pagination
            highlightOnHover
            searchByList={["code", "name"]}
            className="data-table-head-light"
          />
        </Card>
      </Block>
    </Layout>
  )
}

export default BillingCycleList